module.exports = __webpack_public_path__ + "img/thumbnail_CollaredPeccary_m_normal.b77958c6.png";